export default __webpack_public_path__ + "static/media/success.ccd0deaf.svg";